import { render, staticRenderFns } from "./UserContainer.vue?vue&type=template&id=15299dc6&"
import script from "./UserContainer.vue?vue&type=script&lang=js&"
export * from "./UserContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports